<template>
  <div
    v-if="additionalCoverageOptions.length"
    class="addon-card addon-card--coverage"
  >
    <h4 class="addon-card__heading">
      Дод. покриття
      <span class="addon-card__icon"><AdditionalCoverageIcon /></span>
    </h4>
    <p class="addon-card__description">
      Рекомендуємо розширити ліміти страхового покриття, особливо для жителів великих міст
    </p>
    <Select
      class="addon-card__select"
      :value="additionalCoverage"
      :options="additionalCoverageOptions"
      :select-first-by-default="false"
      :clearable="additionalCoverage !== null && !isMandatory"
      :is-disabled="isDisabled"
      placeholder="Додаткове покриття"
      @change="onAdditionalCoverageOptionChange"
    />
  </div>
</template>

<script>
import { Select } from '@/shared/ui/form';
import { AdditionalCoverageIcon } from '@/shared/ui/icons';

export default {
  props: {
    additionalCoverageOptions: {
      type: Array,
      default: () => [],
    },
    additionalCoverage: {
      type: String,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isMandatory: {
      type: Boolean,
      default: false,
    },
  },
  components: { AdditionalCoverageIcon, Select },
  methods: {
    onAdditionalCoverageOptionChange(option) {
      this.$emit('additional-coverage-option-changed', option);
    },
  },
};
</script>

<style scoped lang="scss">
.addon-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  border-radius: 8px;
  padding: 16px;

  &__heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 8px;
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background-color: #ffffff;
    border-radius: 50%;

    svg {
      width: 24px;
      height: 24px;
    }
  }

  &__description {
    font-size: 14px;
    font-weight: 400;
    margin: 0 50px 16px 0;
    text-align: left;
    word-break: break-word;
    hyphens: auto;

    @media (max-width: 500px) {
      margin: 0 0 16px;
    }
  }

  &__select {
    width: 100%;
  }

  &--coverage {
    background-color: #dff5f4;

    .addon-card__heading {
      color: #499797;
    }

    .addon-card__description {
      color: #71bfbf;
    }
  }
}
</style>
